import React from 'react';
import { View } from 'react-native';
import { storiesOf } from '@storybook/react-native';
import { PanelHeader } from 'src/components/PanelHeader';
import { PlatformPadding } from 'src/components/PlatformPadding';
import { TextField } from 'src/components/TextField';
import { FormField } from 'src/components/FormField';
import { TextArea } from 'src/components/TextArea';

storiesOf('Form', module).add('FormField', () => (
  <>
    <PanelHeader>✉️ FormField</PanelHeader>
    <PlatformPadding horizontal>
      <View>
        <FormField top="Name">
          <TextField placeholder="Eugene" />
        </FormField>
        <FormField top="Email">
          <TextField placeholder="example@mail.com" />
        </FormField>
        <FormField top="Enter your password" bottom="Wrong password" error>
          <TextField value="wrongpassword" secureTextEntry error />
        </FormField>
        <FormField top="Tell about yourself">
          <TextArea placeholder="25y.o. frontend engineer" />
        </FormField>
      </View>
    </PlatformPadding>
  </>
));
